<template>
	<div class="main" v-if="info.hasOwnProperty('id')" v-wechat-title="region.re_name+('-皖云游-'+info.type_name)+'-'+ info.DicName">
		<TravelTop :info="info" :region="region" />

		<TravelAbout v-if="simages.hasOwnProperty(1)" :simages="simages[1]" :summary="info.Summary" />
		<TravelAudio :audios="audios" />
		<div class="container">
			<div class="panel panel-default">
				<div class="panel-heading">
					<div class="category">
						<a class="category-top">基本资料</a>
						<a class="category-bottom">Basic data</a>
					</div>
				</div>
				<div class="panel-body" style="padding:0px;">
					<div class="container">
								<table class="table">
                    <thead>
                        <tr>
                            <th width="18%"></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td class="blue"> <p>中文名称</p></td><td>{{info.DicName?info.DicName:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>所属类别</p></td><td>{{info.JudgeGrade?info.JudgeGrade:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>所属级别</p></td><td>{{info.Honour?info.Honour:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>所属批次</p></td><td>{{info.Batch?info.Batch:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>评定时间</p></td><td>{{info.JudgeTime?info.JudgeTime:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>历史起源</p></td><td>{{info.HistoricalOrigin?info.HistoricalOrigin:'暂无'}}</td></tr>
                        <tr><td class="blue"><p>传承代表</p></td><td>{{info.Inheritor?info.Inheritor:'暂无'}}</td></tr>
                        <tr>
                                    <td class="blue"><p>行政区划</p></td>
                                    <td v-if="info.city && info.district">安徽省-{{info.city.RegionName}}-{{info.district.RegionName}}{{info.town?'-'+info.town.RegionName:''}}</td>
                                    <td v-else>暂无</td>
                                </tr>
												<tr style="height:20px;"><td></td><td></td></tr>
                    </tbody>
                </table>
                
            
						
						
					</div>
				</div>
			</div>
		</div>
		<!--平面导览-->
		<TravelImage v-if="simages.hasOwnProperty(2)" :simages="simages[2]" />

		<TravelVideo :videos="videos" />

		<TravelEcommerce :list="ecommerces" />
    <TravelDetail name="主要内容" enname="Primary Coverage" :detail="info.Detail" />
    <TravelDetail name="历史渊源" enname="Historical Origin" :detail="info.History" />
		<TravelDetail name="现代传承" enname="Modern Inheritance" :detail="info.ModernInheritance" />
		<TravelLocalcelebrity :list="localcelebrities" name="非遗传承人" enname="Inheritor" />

		<TravelDetail name="文化典故" enname="Cultural Allusion" :detail="info.Cultural" />
		<TravelDetail name="文献记载" enname="Documnet Record" :detail="info.ArchiveRecord" />
		<TravelDetail name="代表作品" enname="Representative Works" :detail="info.RepresentativeWork" />
    <TravelDetail name="相关场所" enname="Related Places" :detail="info.RelatedPlaces" />
    <TravelDetail name="相关产品" enname="Related Products" :detail="info.RelatedProducts" />


		<Scolllist></Scolllist>
		<!-- 相关词条 -->
		<TravelRelevant :dicrelevants="dicrelevants"/>
		<TravelFooter :info="info" :region="region" />
	</div>
</template>
<script>

import Scolllist from "@/components/Scolllist";
import { travelInfo } from '@/api/travel'
import TravelDetail from '@/components/travel/detail'
import TravelRelevant from '@/components/travel/relevant'
import TravelScenicmianspots from '@/components/travel/scenicmianspots'
import TravelVideo from '@/components/travel/video'
import TravelImage from '@/components/travel/image'
import TravelMap from '@/components/travel/map'
import TravelAbout from '@/components/travel/about'
import TravelTop from '@/components/travel/top'
import TravelFooter from '@/components/travel/footer'
import TravelAudio from '@/components/travel/audio'
import TravelLocalcelebrity from '@/components/travel/localcelebrity'
import TravelEcommerce from '@/components/travel/ecommerce'
import TravelRoom from '@/components/travel/room'
import TravelFacilities from '@/components/travel/facilities'
import TravelDish from '@/components/travel/dish'
export default {
    data() {
        return {
            info: this.$store.state.acc,
            user: this.$store.state.user,
            center: { lng: 0, lat: 0 },
            info: {},
            region: {},
            simages: {},
            ecommerces: [],
            traffic: {},
            dicrelevants: [],
            videos:[],
            audios:[],
            localcelebrities: [],
            rooms: [],
            meetings: [],
            facilities: [],
            dishs: [],
            balconies: [],
        }
    },
    components: {
			TravelMap,
			TravelDetail,
			TravelRelevant,
			TravelScenicmianspots,
			TravelVideo,
			TravelImage,
			TravelAbout,
			TravelTop,
			TravelFooter,
			TravelAudio,
			TravelLocalcelebrity,
			TravelEcommerce,
			TravelRoom,
			TravelFacilities,
			TravelDish,
      Scolllist
		},
    created(e) {
    	this.getInfo()
    },
    methods: {
    	getInfo (){
    		this.$toast.loading({
		      message: '加载中...',
		      forbidClick: false,
		      loadingType: 'spinner',
		      duration: 10000
		    });
    		travelInfo({type: 'NonHeritage', id: this.$route.params.id}).then(res=> {
    			this.$toast.clear()
          this.info = res.info
          this.region = res.Region
          this.$store.commit('SET_RGION', this.region)
          this.simages = res.Images
          this.traffic = res.traffic
          this.audios = res.audios
          this.videos = res.videos
          this.balconies = res.balconies
          this.dishs = res.dishs
          this.facilities = res.facilities
          this.localcelebrities = res.localcelebrities
          
          this.ecommerces = res.ecommerces
          this.dicrelevants = res.dicrelevants

    		})
    	},
    	
    }
};
</script>
<style>
	body{
		height: auto;
	}
</style>